/* eslint-disable import/newline-after-import */
/* eslint-disable prettier/prettier */
import axios from 'axios';
const API_URL = "https://banca.siatigroup.com/api/";
export const api = axios.create({
    baseURL: API_URL,
});
export default api;